import _slicedToArray from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
var AUTO_INTERVAL = 200;
var STEP_BUCKETS = [[30, 0.05], [70, 0.03], [96, 0.01]];
export default function usePercent(spinning, percent) {
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mockPercent = _React$useState2[0],
    setMockPercent = _React$useState2[1];
  var mockIntervalRef = React.useRef();
  var isAuto = percent === 'auto';
  React.useEffect(function () {
    if (isAuto && spinning) {
      setMockPercent(0);
      mockIntervalRef.current = setInterval(function () {
        setMockPercent(function (prev) {
          var restPTG = 100 - prev;
          for (var i = 0; i < STEP_BUCKETS.length; i += 1) {
            var _STEP_BUCKETS$i = _slicedToArray(STEP_BUCKETS[i], 2),
              limit = _STEP_BUCKETS$i[0],
              stepPtg = _STEP_BUCKETS$i[1];
            if (prev <= limit) {
              return prev + restPTG * stepPtg;
            }
          }
          return prev;
        });
      }, AUTO_INTERVAL);
    }
    return function () {
      clearInterval(mockIntervalRef.current);
    };
  }, [isAuto, spinning]);
  return isAuto ? mockPercent : percent;
}